import { Grid, Tab, Tabs } from '@material-ui/core'
import classnames from 'classnames'
import React, { ChangeEvent, FC, useContext } from 'react'

import { CheckoutNavigationBarOptionsContext, NavigationBarOption } from '../../../layouts/context'
import { usePageUrl } from '../../../lib/pages'
import useStyles from './styles/checkoutNavigationBar'

export interface CheckoutNavigationBarProps {
  checkoutNavigationBarTabValue: number
}

// Copied directly from a Material UI example. May not be
// exactly what we want, but it's a start:
const a11yProps = ({ index }: { index: number }) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
})

const clickedTabPath = ({
  value,
  navigationBarOptions,
}: {
  value: number
  navigationBarOptions: NavigationBarOption[]
}): string | null => {
  const clickedTab = navigationBarOptions.find(
    (checkoutNavigationBarOption) => checkoutNavigationBarOption.value === value,
  )

  return clickedTab ? `/checkout/${clickedTab.label}/` : null
}

const CheckoutNavigationBar: FC<CheckoutNavigationBarProps> = ({
  checkoutNavigationBarTabValue,
}) => {
  const classes = useStyles()
  const { navigationBarOptions, loading } = useContext(CheckoutNavigationBarOptionsContext)
  const { navigate } = usePageUrl()

  const handleChange = (_event: ChangeEvent<Record<string, unknown>>, newValue: number) => {
    const path = clickedTabPath({ value: newValue, navigationBarOptions })
    if (path) {
      navigate(path)
    }
  }

  return (
    <Grid
      className={classnames('checkoutNavigationBar', classes.checkoutNavigationBar)}
      item
      xs={12}
    >
      <Tabs
        centered
        classes={{ indicator: classes.tabIndicator }}
        onChange={handleChange}
        value={checkoutNavigationBarTabValue}
        variant="fullWidth"
      >
        {/* eslint-disable react/jsx-props-no-spreading */}
        {!loading &&
          navigationBarOptions.map((navOption) => (
            <Tab
              classes={{ root: classes.tabRoot }}
              className={
                navOption.value <= checkoutNavigationBarTabValue
                  ? classes.currentOrCompletedCheckoutTab
                  : ''
              }
              disabled={navOption.value > checkoutNavigationBarTabValue}
              key={navOption.value}
              label={navOption.label}
              {...a11yProps({ index: navOption.value })}
            />
          ))}
        {/* eslint-enable react/jsx-props-no-spreading */}
      </Tabs>
    </Grid>
  )
}

export default CheckoutNavigationBar
